import { Tab, Tabs } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useTabStyles } from "~/components/GenericTab";
import { MapContentTypes } from "./ProjectMapContent";

type MapTabsProps = {
  currentTab: MapContentTypes;
  setCurrentTab: (value: React.SetStateAction<MapContentTypes>) => void;
};

export const MapTabs = React.memo(
  ({ currentTab, setCurrentTab }: MapTabsProps): JSX.Element => {
    const classes = useTabStyles();

    const { t } = useTranslation();
    return (
      <Tabs
        TabIndicatorProps={{ className: classes.indicator }}
        value={currentTab}
        onChange={(_e, value: MapContentTypes) => setCurrentTab(value)}
      >
        <Tab
          sx={{
            justifyContent: "flex-end",
            paddingBottom: "5px !important",
          }}
          value="map-control"
          label={t("projects:filterTab")}
        />
        <Tab
          sx={{
            justifyContent: "flex-end",
            paddingBottom: "5px !important",
          }}
          value="poi-items"
          label={t("projects:poiItems")}
        />
      </Tabs>
    );
  },
);

MapTabs.displayName = "MapTabs";
